module.exports = __webpack_public_path__ + "img/jingshen.be330173.png";